export const searchFormClickTrackingLoc = 'Search Form';
export const autosuggestionsClickTrackingLoc = 'Suggested place:';
export const CityPickListDesktopCountForRecentSearches = 5;
export const CityPickListMobileCountForRecentSearches = 4;
export const CountForRecentSearches = 3;
export const datepickerResetClickTrackingLoc = 'Reset';
export const groupPartnersError = 'groupPartners';
export const travelAgentsError = 'travelAgents';
export const travelAgentsErrorClickTrackingValue = 'Travel Agents Error';
export const groupPartnersErrorClickTrackingValue = 'Group Partners Error';
export const hardCodedAllLocale = 'all';
export const localizedFormattingRequiredLocales = ['ja-JP', 'ko-KR'];
export const corporateCodeFormatLengthInvalidError = 'corporateCodeFormatLengthInvalid';

export const ELEMENT_INPUT = 'input';
export const ELEMENT_BUTTON = 'button';
export const LOCALES_FOR_ROOMS_AND_GUEST_DISPLAY_VALUE_CHANGES = ['es-es', 'it-it', 'fr-fr', 'pt-br', 'ru-ru', 'pl-pl'];
